<template>
  <div class="">
    <p>جست و جو</p>
    <b-form-input
        @keypress.enter.prevent="search"
        v-model="searchWords"
        placeholder="نام، نام خانوادگی یا شماره تلفن کاربر"
    ></b-form-input>
  </div>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      searchWords: '',
    }
  },
  methods: {
    search() {
      let page = 1
      this.$store.commit('User/setFilters', {key: 'search', value: this.searchWords})
      this.$store.dispatch("User/getPersons", page);
    }
  },
  destroyed() {
    this.$store.commit('User/setFilters', {key: 'search', value: ''})
  }
}
</script>

<style scoped>

</style>